// removed by extract-text-webpack-plugin
module.exports = {"forgot-password":"login__forgot-password___1Ej-K","message":"login__message___1KWay","badCredentialsMessage":"login__badCredentialsMessage___2uy90","signUpSection":"login__signUpSection___3sP3M","privacyPolicy":"login__privacyPolicy___N-FrG","rememberMe":"login__rememberMe___1P1g7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/login/login.scss
// module id = 1247
// module chunks = 0